import { combineReducers } from 'redux';

import global from './userManagementReducer'; // old reducer
import eligibilityReducer from '../components/eligibility/reducer';

export default combineReducers({
  global,
  eligibilityReducer,
});
